/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 13:51:25
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 11:01:59
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/DomainRegistration/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import { Button } from 'antd';
import React from 'react';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const DomainRegistration = ({
  handleUploadFile,
  applePayRegistration,
  lastUploadDate,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      // containerClassName={css.invoiceFormat}
      title={getI18n(
        'salesChannelPayment.index.stripeApplePayDomainRegistration',
      )}>
      <p>
        {getI18n(
          'salesChannelPayment.index.stripeApplePayDomainRegistrationContent',
        )}
        <a
          className={css.viewInstructions}
          target='_blank'
          href='https://support.stripe.com/questions/enable-apple-pay-on-your-stripe-account'>
          {getI18n('salesChannelPayment.index.viewinstructions')}
        </a>
      </p>

      {applePayRegistration ? (
        <div className={css.domainRegistration}>
          <Icon type='iconpages' />
          <span>{applePayRegistration}</span>
          <span className={css.lastUploadDate}>{` (${lastUploadDate})`}</span>
        </div>
      ) : (
        <div className={css.domainRegistration}>NA</div>
      )}
      <Button type='primary' onClick={handleUploadFile} disabled={disableEdit}>
        {applePayRegistration
          ? getI18n('salesChannelPayment.index.replaceFile')
          : getI18n('salesChannelPayment.index.uploadFile')}
      </Button>
    </SectionWrapper>
  );
};

export default DomainRegistration;
